import { storeToRefs } from "pinia"
import { helpers } from "@vuelidate/validators"
import { useRentalDispenseItemStore } from "@/store/rental-dispense-item.store.ts"
import type { RentalDispenseItem } from "@/models/rental-dispense-item.model.ts"

export const uniqueRentalDispenseItemValidator = helpers.withMessage(
  "Er bestaat al een verhuurartikel met deze naam en eenheid",
  (rentalDispense: RentalDispenseItem) => {
    const rentalDispenseStore = useRentalDispenseItemStore()
    const { rentalDispenseItems } = storeToRefs(rentalDispenseStore)

    if (!rentalDispense.name || !rentalDispense.unit) {
      return true
    }

    return !rentalDispenseItems.value.some(
      (item) =>
        item.name.toLowerCase() === rentalDispense.name.toLowerCase() &&
        item.unit === rentalDispense.unit &&
        item.id !== rentalDispense.id
    )
  }
)
